import React from 'react';
import { checkFreePackage } from '@src/services/package';
import CheckOrCross from '../Shared/CheckOrCross';

const previewFeatures = ({ packages }) =>
  packages.map((pkg) => (
    <CheckOrCross key={pkg.code} isCheck={!checkFreePackage(pkg?.code)} />
  ));

export default previewFeatures;
